import React from "react";
import MainLayout from "../../components/MainLayout/MainLayout";
import Head from "next/head";

const PrivacyPolicy = () => {
  return (
    <>
      <MainLayout>
        <main id="ContentBox">
          <div className="Aboutlist sticky">
            <div className="container">
              <h2>Privacy Policy</h2>
            </div>
          </div>
          <div className="Statside">
            <div className="container">
              <p>
                The website located at https://www.ShotQuality.com ("Website") is owned and operated by ShotQ LLC (the
                "Company"). We created this Privacy Policy ("Policy") to demonstrate our commitment to protecting your
                privacy and your personally identifiable information on our Website.
              </p>
              <p>
                This Policy is based on the principles of notice/awareness, choice/consent, access/participation and
                integrity/security in the collection and use of all information regarding our users and their activities
                on the Website. In this document "You" shall refer to you, the end user of this site, whether as an
                individual, entity, company, organization or related. "We", the "Website", and/or the "Company", refers
                to the information, services, and other provisions by the Company, or located at the Website, or by
                individuals and entities associated with the Website.
              </p>
              <h2>I. Notice of our policy</h2>
              <p>
                This Policy notifies you of, among other things: (i) what information we gather from you, (ii) how we
                may use or disclose that information, (iii) with whom the information may be shared, (iv) what choices
                are available to you regarding the collection, use and distribution of the information, (v) our efforts
                to protect the information, and (vi) how you can correct any inaccuracies in the information you provide
                to us. Please read this Policy carefully.
              </p>
              <h2>II. What types of information are collected and why</h2>
              <h3>a. Information Submitted by You</h3>
              <p>
                We do not request you to submit any information to the Website. Any communications, emails, or other
                information submitted by You to the website, or individuals related to the site is solely at your own
                election. The website has no responsibility or other obligation to store, maintain, respond or otherwise
                with respect to the information transmitted to the Website by you. You will be contacted by us only if
                you have expressly requested us to do so.
              </p>
              <h3>b. Information Collected by Cookies</h3>
              <p>
                The Website uses "cookies" to help you use our services more easily. A "cookie" is a small data file
                that a website can send to your browser, which may then be stored on your computer to help our Website
                "remember" information about you to make it easier and more efficient for you to use our Website.
              </p>
              <p>
                Our Website also employs session cookies. A session cookie does not remain on your computer after you
                close your web browser window. Our session cookies contain none of your personal information and cannot
                be used to track you around the Internet. Our session cookies can only be used by this Website and they
                only exist for the duration of your visit.
              </p>
              <p>
                Depending on the settings in your browser, you may have the option to deny the use of cookies; however,
                doing so may negatively impact upon the performance of the Website or restrict us in better serving your
                needs and interests. The "help" portion of the toolbar on most browsers will tell you how to prevent
                your browser from accepting new cookies, how to have the browser notify you when you receive a new
                cookie, or how to disable cookies altogether.
              </p>
              <h2>III. How does the Company use my information?</h2>
              <h3>a. Use of Your Information</h3>
              <p>
                Any information supplied by you is used to improve your experience, process and personalize your
                requests, improve the Website, develop new features, for support, and may be used for other purposes as
                stated herein.
              </p>
              <p>
                We may also use the information to show you a history of your activity, to provide you with statistics
                about you or your use of our product or service, or to provide you with a better user experience.
              </p>
              <p>
                The information collected may also be used to provide relevant advertisements, promotional messages and
                materials, or any other way as the Company deems fit.
              </p>
              <p>
                Currently, the only information stored by the Website is your email and encrypted password (for
                subscribers) and your favorite team, if supplied. Your unencrypted password is not stored by the
                Website.
              </p>
              <p>
                We may also retain your Data on a secure server and use this information in an aggregated form to
                measure number of visits, average time spent on the Website, pages viewed, and other relevant
                statistics.
              </p>
              <h3>b. Disclosure of Your Information</h3>
              <p>
                The information we collect will only be collected upon your consent to this privacy policy. We will not
                share your information with third parties. However, the Company reserves the right to disclose your
                personally identifiable information as required by law and when the Company believes that disclosure is
                necessary to protect the rights of the Company, and/or to comply with any judicial proceeding, court
                order, subpoena, or legal process served upon the Company.
              </p>
              <h3>c. Managing Your Information</h3>
              <p>
                You are entitled to removal of your Data from our database upon request. You may request us to correct,
                modify or delete all of your Data collected by us through the Website, by making such a request or a
                related inquiry by sending an email to ratings at ShotQuality.com. Unless you require us to delete your
                Data, we will keep your information for as long as reasonably necessary for the purposes described in
                this Policy and for us to keep appropriate archives for our business operations.
              </p>
              <h3>d. Anonymous Data Collection</h3>
              <p>
                We may anonymize and aggregate data from your usage of the Website to obtain or provide general
                statistics regarding the use of the Website and its specific features and functionalities that you use.
              </p>
              <h2>IV. What does the Company do to keep the Website secure?</h2>
              <p>
                The Company employs procedural and technical safeguards to secure the Website against misuse. Regardless
                of the precautions taken by us we cannot ensure or warrant the security of any information you transmit
                to us, and you transmit such information at your own risk.
              </p>
              <h2>V. Acceptance of this Privacy Policy</h2>
              <p>
                By using this Website, you agree to this Website Privacy Policy. We reserve the right, at our
                discretion, to change, modify, add, and or remove portions of this Privacy Policy at any time. All
                changes shall take effect immediately upon their posting on our Website. Your continued use of Website
                or acceptance of emails following the posting of changes to this Privacy Policy shall mean that you
                accept any and all such changes.
              </p>
            </div>
          </div>
        </main>
      </MainLayout>
    </>
  );
};

export default PrivacyPolicy;
